import { render, staticRenderFns } from "./GoodsReturnEditItems.vue?vue&type=template&id=16960c38&scoped=true"
import script from "./GoodsReturnEditItems.vue?vue&type=script&lang=js"
export * from "./GoodsReturnEditItems.vue?vue&type=script&lang=js"
import style0 from "./GoodsReturnEditItems.vue?vue&type=style&index=0&id=16960c38&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16960c38",
  null
  
)

export default component.exports